import React from "react";
import { Item, Grid, Button, Icon, Message } from "semantic-ui-react";
import { Trans, useTranslation } from "react-i18next";
import { format } from "date-fns";

import { FORMAT_DATE, FORMAT_TIME } from "../../../../common/dateFormats";
import nl2br from "../../../../common/nl2br";
import PromptButton from "../../../prompt/PromptButton";
import CancelForm from "../CancelForm";

function Information({
  isCancelModalOpen,
  onOpenCancelModal,
  onCloseCancelModal,
  onActivate,
  onCancel,
  canCancelTrainingUnit,
  canActivateTrainingUnit,
  trainingUnit: {
    active,
    id,
    date,
    courseDate: {
      maximumParticipants,
      course: { duration, description },
      location,
      room
    },
    waitingListPosition,
    isRegistered
  }
}) {
  const { t } = useTranslation();

  return (
    <>
      {active && canCancelTrainingUnit && (
        <Button
          floated="right"
          primary
          negative
          icon
          onClick={onOpenCancelModal}
          labelPosition="left"
        >
          <Icon name="times" />
          <Trans i18nKey="coursePlan.details.actions.cancel" />
        </Button>
      )}
      {!active && canActivateTrainingUnit && (
        <PromptButton
          floated="right"
          primary
          icon
          promptType="respawn"
          promptTitle={<Trans i18nKey="coursePlan.prompt.activate" />}
          onConfirm={onActivate}
        >
          <Icon name="redo" />
          <Trans i18nKey="coursePlan.details.actions.activate" />
        </PromptButton>
      )}

      <CancelForm
        id={id}
        isOpen={isCancelModalOpen}
        onClose={onCloseCancelModal}
        onCancel={onCancel}
      />

      {waitingListPosition > 0 ? (
        <Message color="yellow">
          Du bist auf Position <strong>{waitingListPosition}</strong> der
          Warteliste.
        </Message>
      ) : (
        isRegistered && (
          <Message success>Du bist für diese Einheit angemeldet.</Message>
        )
      )}

      <div className="ui divider hidden" />

      <Grid stackable columns="2">
        <Grid.Row>
          <Grid.Column>
            <Item.Group unstackable>
              <Item>
                <Item.Content verticalAlign="middle">
                  <Item.Meta>
                    <Trans i18nKey="courses.labels.location" />
                  </Item.Meta>
                  {location.name}
                  {room && ` (${t("courses.labels.room")}: ${room})`}
                  <div className="ui divider" />
                </Item.Content>
              </Item>
              <Item>
                <Item.Content verticalAlign="middle">
                  <Item.Meta>
                    <Trans i18nKey="courses.labels.date" />
                  </Item.Meta>
                  {format(new Date(date), FORMAT_DATE)}{" "}
                  {format(new Date(date), FORMAT_TIME)}
                  <div className="ui divider" />
                </Item.Content>
              </Item>
            </Item.Group>
          </Grid.Column>
          <Grid.Column>
            <Item.Group unstackable>
              <Item>
                <Item.Content verticalAlign="middle">
                  <Item.Meta>
                    <Trans i18nKey="courses.labels.duration" />
                  </Item.Meta>
                  {duration}
                  <div className="ui divider" />
                </Item.Content>
              </Item>
              <Item>
                <Item.Content verticalAlign="middle">
                  <Item.Meta>
                    <Trans i18nKey="courses.labels.maximumParticipants" />
                  </Item.Meta>
                  {maximumParticipants}
                  <div className="ui divider" />
                </Item.Content>
              </Item>
            </Item.Group>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column columns={2}>
            <Item.Group>
              <Item>
                <Item.Content verticalAlign="middle">
                  <Item.Meta>
                    <Trans i18nKey="courses.labels.description" />
                  </Item.Meta>
                  {nl2br(description)}
                </Item.Content>
              </Item>
            </Item.Group>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </>
  );
}

Information.displayName = "coursePlan/details/information/Information";

export default React.memo(Information);
